import React, { useEffect, useState } from "react";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import IconButton from "@material-ui/core/IconButton";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import Collapse from "@material-ui/core/Collapse";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableBody from "@material-ui/core/TableBody";
import { useTableRowStyles } from "./collapsible-table.styles";
import MultilineTableCell from "./MultilineTableCell";
import { Button, Icon, Tooltip } from "@material-ui/core";
import {
  ReservationType,
  TravellerTypes,
} from "../../../types/service-types/ReservationTypes";
import { toggleQuickPanel } from "../quick-panel/store";
import { useRouteMatch } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import history from "@history";
import ModalDialog from "../modal-dialog/ModalDialog";
import { deleteSchedule } from "../../schedules/store/delete-schedule.slice";
import DateUtils from "../../../utils/DateUtils";
import PrintIcon from "@material-ui/icons/Print";
import PersonAddOutlinedIcon from "@material-ui/icons/PersonAddOutlined";
import { ROLES } from "../../../constants/roles";
import { updateStatusPassenger } from "../../schedules/store/update-passenger.slice";
import { deleteTraveler } from "../../schedules/store/delete-traveler.slice";
import { deleteFlight } from "../../schedules/store/delete-flight-from-traveler.slice";
import { errorMsg, successMsg, warningMsg } from "../../../utils/MessageUtils";
import { useTranslation } from "react-i18next";
import EditIcon from "../edit-icon/EditIcon";
import { flightShow } from "../../schedules/store/flight-show.slice";
import { disableFlight } from "../../schedules/store/disable-flight-from-traveler.slice";
import { AppState } from "../../../store";
import useAuthority from "../../../hooks/useAuthority";
import ComponentToPrintReservation from "../../PrintInvoice/ComponentToPrintReservation";
import ComponentToPrintTravelers from "../../PrintInvoice/ComponentToPrintTravelers";
import reservationServices from "app/services/reservation.services";
import { getAccount } from "../../../account/store/get-account.slice";
import { filterSchedules } from "../../schedules/store/filter-schedules.slice";
interface IProps {
  row: ReservationType;
}

const CollapsibleTableRow = (props: IProps) => {
  const classes = useTableRowStyles();
  const [showPrintInvoice1, setShowPrintInvoice1] = useState(false);
  const [showDetails, setShowDetails] = useState(false);
  const [showTravelerDetails, setShowTravelerDetails] = useState(false);
  const [showPrintInvoice1Single, setShowPrintInvoice1Single] = useState(false);
  const dispatch = useDispatch();
  const { hasUserAnyAuthority } = useAuthority();
  let { url } = useRouteMatch();
  const { t } = useTranslation();

  // permissions that admin give the agent
  const scopes = useSelector(
    (state: AppState) => state.account.account.account?.scopes,
  );

  const scopesList: string[] = Array.isArray(scopes)
    ? (scopes as string[])
    : [];

  const canBookFlights =
    hasUserAnyAuthority([ROLES.ROLE_ADMIN]) ||
    scopesList.includes("FLIGHT_RESERVATION");

  const [restoring, setRestoring] = useState(false);
  const filters = useSelector(
    (state: AppState) => state.schedules.filterSchedules,
  );

  const restoreReservation = async () => {
    if (restoring) return;
    setRestoring(true);
    try {
      await reservationServices.restoreReservation(props.row.id);
      dispatch(successMsg(t(
        "app.main.schedules.restore.success",
        "Reservation restored successfully!",
      )));
      dispatch(filterSchedules({ ...filters, page: 0 }));
      dispatch(getAccount() as any);
    } catch (err: any) {
      dispatch(errorMsg(
        err?.data?.message || err?.response?.data?.message ||
        t("app.main.schedules.restore.error", "Unable to restore the reservation."),
      ));
    } finally {
      setRestoring(false);
    }
  };

  const [modal, setModal] = useState({ open: false, deleteId: "" });
  const [reservation, setReservation] = useState<any>();
  const [traveler, setTraveler] = useState<any>();

  const [hasButton, setHasButton] = useState(false);
  const [hasNoteButton, setHasNoteButton] = useState(false);
  const [hasActivitiesButton, setHasActivitiesButton] = useState(false);
  const [hasChangePassengerButton, setHasChangePassengerButton] =
    useState(false);
  const [hasChangeContactor, setHasChangeContactor] = useState(false);
  const [hasConfirmViber, setHasConfirmViber] = useState(false);
  const [hasPriceButton, setHasPriceButton] = useState(false);
  const [hasShowButton, setHasShowButton] = useState(false);
  const [hasDeactivateButton, setHasDeactivateButton] = useState(false);
  const [hasDeleteFlightButton, setHasDeleteFlightButton] = useState(false);
  const [hasChangeTravelerFlight, setHasChangeTravelerFlight] = useState(false);
  const [hasReturnTravelerFlight, setHasReturnTravelerFlight] = useState(false);
  const [hasSplitButton, setHasSplitButton] = useState(false);
  const [hasCancelButton, setHasCancelButton] = useState(false);
  const [hasSubagentButton, setHasSubagentButton] = useState(false);
  const [noFlightModalOpen, setNoFlightModalOpen] = useState(false);

  const flightDate = new Date(props.row.createdDate);
  const isPastFlight = flightDate < new Date();

  /**
   * IMPORTANT FIX:
   * Booking flights permission is FLIGHT_RESERVATION (plus ADMIN).
   * This must control "Book Going Flight" and "Book Return Flight" visibility.
   */

  const printInvoice1 = (reservation: any, showDetails: boolean) => {
    setReservation(reservation);
    setShowPrintInvoice1(true);
    setShowDetails(showDetails);
  };

  const printInvoice1Single = (
    reservation: any,
    traveler: any,
    showDetails: boolean,
  ) => {
    setReservation(reservation);
    setTraveler(traveler);
    setShowPrintInvoice1Single(true);
    setShowTravelerDetails(showDetails);
  };

  const showPrint1 = (value: any) => setShowPrintInvoice1(value);
  const showPrint1Single = (value: any) => setShowPrintInvoice1Single(value);

  const disableFlightModalState = {
    open: false,
    travelerId: "",
    flight: "",
    flightName: "",
  };

  const showedFlightModalState = {
    open: false,
    travelerId: "",
    status: false,
    flight: "",
    flightName: "",
  };

  const [deleteFlightModal, setDeleteFlightModal] = useState({
    open: false,
    travelerId: "",
    flight: "",
    flightName: "",
  });

  const [statusTravelerModal, setStatusTravelerModal] = useState({
    open: false,
    reservationId: "",
    travelerId: "",
    status: false,
  });

  const [deleteTravelerModal, setDeleteTravelerModal] = useState({
    open: false,
    reservationId: "",
    travelerId: "",
    status: false,
  });

  const [disableFlightModal, setDisableFlightModal] = useState(
    disableFlightModalState,
  );
  const [showedFlightModal, setShowedFlightModal] = useState(
    showedFlightModalState,
  );
  const [printing, setPrinting] = useState(false);

  // HANDLER FOR DISABLE/ENABLE FLIGHT
  const disableFlightHandler = (
    travelerId: string,
    flight: string,
    depFlight: any,
    arrFlight: any,
  ) => {
    setDisableFlightModal({
      open: true,
      travelerId,
      flight,
      flightName: `${depFlight} => ${arrFlight}`,
    });
  };

  //HANDLER FOR SHOW/NO-SHOW FLIGHT
  const showedFlightHandler = (
    travelerId: string,
    status: boolean,
    flight: string,
    depFlight?: string,
    arrFlight?: string,
  ) => {
    setShowedFlightModal({
      open: true,
      travelerId,
      status,
      flight,
      flightName: `${depFlight} => ${arrFlight}`,
    });
  };

  const deleteFlightHandler = (
    travelerId: string,
    flight: string,
    depFlight: any,
    arrFlight: any,
  ) => {
    setDeleteFlightModal({
      open: true,
      travelerId,
      flight,
      flightName: `${depFlight} - ${arrFlight}`,
    });
  };

  const disableTravelerHandler = (
    reservationId: string,
    travelerId: string,
    travelerAgeCategory: string,
    status: boolean,
  ) => {
    const travelers = props.row.travelers;
    let infantCount = 0;
    let adultCount = 0;

    travelers.forEach((trav) => {
      if (trav.status) {
        if (trav.ageCategory === "INF") infantCount += 1;
        else if (trav.ageCategory === "ADULT") adultCount += 1;
      }
    });

    if (
      !status &&
      travelerAgeCategory === "ADULT" &&
      infantCount >= adultCount
    ) {
      dispatch(
        warningMsg(
          "Not allowed to disable adult if there are more infants than adults in the flight",
        ),
      );
    } else {
      setStatusTravelerModal({
        open: true,
        reservationId,
        travelerId,
        status,
      });
    }
  };

  const deleteReservationHandler = (id: string) => {
    setModal({ open: true, deleteId: id });
  };

  useEffect(() => {
    CheckTooAddPassenger();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [scopes]);

  const {
    id,
    confirmationCode,
    contactNumber,
    secondaryContactNumber,
    createdByRole,
    invoiceInTheNameOf,
    languageOfSupervisor,
    status,
    source,
    supervisor,
    travelers,
    emailOfSupervisor,
    createdDate,
    invoice,
    disquisitions,
     provision,
    smsResponses,
    emailResponses,
    currency,
    pnrCode,
    externalReservationId,
  } = props.row;

  const [open, setOpen] = useState(true);
  let lastDisquisitions = disquisitions[disquisitions.length - 1];
  const allTravellersDisabled = travelers.every((t) => !t.status);
  const toggleOpen = () => setOpen(!open);

  const checkAgeAndGender = (age: string, gender: string) => {
    if (age === "ADULT" && gender === "MALE") return "MR";
    if (age === "ADULT" && gender !== "MALE") return "MRS";
    if (age === "CHILD") return "CHD";
    return age;
  };

  const CheckTooAddPassenger = () => {
    /**
     * IMPORTANT FIX:
     * Reset all flags first, otherwise they can remain "true" from a previous user/session.
     */
    setHasButton(false);
    setHasNoteButton(false);
    setHasActivitiesButton(false);
    setHasChangePassengerButton(false);
    setHasChangeContactor(false);
    setHasConfirmViber(false);
    setHasPriceButton(false);
    setHasShowButton(false);
    setHasDeactivateButton(false);
    setHasDeleteFlightButton(false);
    setHasChangeTravelerFlight(false);
    setHasReturnTravelerFlight(false);
    setHasSplitButton(false);
    setHasCancelButton(false);
    setHasSubagentButton(false);

    if (scopes && hasUserAnyAuthority([ROLES.ROLE_CALL_AGENT])) {
      scopes.map((x: any) => {
        if (x === "VIBER_CONFIRMATION") setHasConfirmViber(true);
        if (x === "UPDATE_CONTACT") setHasChangeContactor(true);
        if (x === "UPDATE_TRAVELERS") setHasChangePassengerButton(true);
        if (x === "UPDATE_TRAVELER_FLIGHTS") setHasChangeTravelerFlight(true);
        if (x === "RESERVATION_DISCUSSION") setHasNoteButton(true);
        if (x === "SPLIT_RESERVATIONS") setHasSplitButton(true);
      });
    }

    if (
      scopes &&
      hasUserAnyAuthority([ROLES.ROLE_AGENT, ROLES.ROLE_SUB_AGENT])
    ) {
      scopes.forEach((x: any) => {
        switch (x) {
          case "ADD_TRAVELER":
            setHasButton(true);
            break;
          case "RESERVATION_DISCUSSION":
            setHasNoteButton(true);
            break;
          case "ACTIVITIES":
            setHasActivitiesButton(true);
            break;
          case "UPDATE_TRAVELERS":
            setHasChangePassengerButton(true);
            break;
          case "UPDATE_CONTACT":
            setHasChangeContactor(true);
            break;
          case "CONFIRM_VIBER":
            setHasConfirmViber(true);
            break;
          case "UPDATE_TRAVELER_PRICES":
            setHasPriceButton(true);
            break;
          case "SHOW_TRAVELERS":
            setHasShowButton(true);
            break;
          case "DEACTIVATE_TRAVELER":
            setHasDeactivateButton(true);
            break;
          case "DELETE_TRAVELERS":
            setHasDeleteFlightButton(true);
            break;
          case "UPDATE_TRAVELER_FLIGHTS":
            setHasChangeTravelerFlight(true);
            break;
          case "CANCELLATION_OF_RESERVATION":
            setHasCancelButton(true);
            break;
          case "ALLOW_CREATING_SUB_AGENTS":
            setHasSubagentButton(true);
            break;
          default:
            break;
        }
      });
    }

    if (scopes && hasUserAnyAuthority([ROLES.ROLE_ADMIN])) {
      setHasButton(true);
      setHasNoteButton(true);
      setHasActivitiesButton(true);
      setHasChangePassengerButton(true);
      setHasChangeContactor(true);
      setHasConfirmViber(true);
      setHasPriceButton(true);
      setHasShowButton(true);
      setHasDeactivateButton(true);
      setHasDeleteFlightButton(true);
      setHasChangeTravelerFlight(true);
      setHasReturnTravelerFlight(true);
      setHasSplitButton(true);
      setHasCancelButton(true);
      setHasSubagentButton(true);
    }
  };

  const translateDeleteModal = () => {
    let x = t(
      "app.main.schedules.module.title.3",
      "Are you sure you want to delete flight ",
    );
    return x + deleteFlightModal.flightName;
  };

  const translateDisableModal = () => {
    return t(
      "app.main.schedules.module.title.4",
      "Are you sure that you want to change status of this booking as no-show",
    );
  };

  const translateShowHideModal = () => {
    let a = t("app.main.schedules.module.title.5", "Are you sure you want to ");
    let b = t("app.main.schedules.module.title.6", "change ");
    let c = t("app.main.schedules.module.title.7", "status to ");
    let d = t("app.main.schedules.module.title.8", "show");
    let e = t("app.main.schedules.module.title.9", "no-show");

    const hideOrShow = showedFlightModal.status ? d : e;
    return a + b + c + hideOrShow;
  };

  const onPrintTraveler = React.useCallback(
    (reservation: ReservationType, traveler: TravellerTypes) => async () => {
      if (!traveler?.status || !traveler?.departureFlight) return;
      try {
        setPrinting(true);
        await reservationServices.printTravelerTicket(traveler.id);
      } catch (e) {
        errorMsg("Could not open server PDF. Printing local copy…");
        printInvoice1Single(reservation, traveler, false);
      } finally {
        setPrinting(false);
      }
    },
    [printInvoice1Single],
  );

  const onPrintAllTickets = React.useCallback(
    (reservation: ReservationType) => async () => {
      try {
        setPrinting(true);
        await reservationServices.printAllTickets(reservation.id);
      } catch (e) {
        errorMsg("Could not open server PDF. Printing local copy…");
        printInvoice1(reservation, false);
      } finally {
        setPrinting(false);
      }
    },
    [printInvoice1],
  );
 const refreshAccountAfterAction = async (action: any) => {
  try {
    await dispatch(action as any);
    dispatch(getAccount() as any);
  } catch (error) {
    console.error(error);
  }

};

  return (
    <React.Fragment>
      {showPrintInvoice1 && (
        <ComponentToPrintReservation
          reservation={reservation}
          showDetails={showDetails}
          showPrint={showPrint1}
        />
      )}

      {showPrintInvoice1Single && (
        <ComponentToPrintTravelers
          reservation={reservation}
          traveler={traveler}
          showPrint={showPrint1Single}
        />
      )}

      {/* DISABLE TRAVELER */}
      <ModalDialog
        mainTitle={t("app.main.schedules.module.title.noshow", "No show") || ""}
        title={
          statusTravelerModal.status
            ? t("app.main.schedules.module.enable.title")
            : t("app.main.schedules.module.disable.title")
        }
        onOk={async () => {
        await refreshAccountAfterAction(
          updateStatusPassenger({
            reservationId: statusTravelerModal.reservationId,
            travelerId: statusTravelerModal.travelerId,
            status: statusTravelerModal.status,
          }),
        );

        setStatusTravelerModal({
          open: false,
          reservationId: "",
          travelerId: "",
          status: false,
        });
      }}
        onCancel={() =>
          setStatusTravelerModal({
            open: false,
            reservationId: "",
            travelerId: "",
            status: false,
          })
        }
        open={statusTravelerModal.open}
      />

      <ModalDialog
        title={t(
          "app.main.schedules.module.title.2",
          "Are you sure you want to delete this?",
        )}
        onOk={async () => {
        await refreshAccountAfterAction(
          deleteTraveler({
            reservationId: deleteTravelerModal.reservationId,
            travelerId: deleteTravelerModal.travelerId,
            status: deleteTravelerModal.status,
          }),
        );

        setDeleteTravelerModal({
          open: false,
          reservationId: "",
          travelerId: "",
          status: false,
        });
      }}
        onCancel={() =>
          setDeleteTravelerModal({
            open: false,
            reservationId: "",
            travelerId: "",
            status: false,
          })
        }
        open={deleteTravelerModal.open}
      />

      <ModalDialog
        title={translateDeleteModal() + " ?"}
        onOk={async () => {
        await refreshAccountAfterAction(
          deleteFlight({
            travelerId: deleteFlightModal.travelerId,
            flight: deleteFlightModal.flight,
          }),
        );

        setDeleteFlightModal({
          open: false,
          travelerId: "",
          flight: "",
          flightName: "",
        });
      }}
        onCancel={() =>
          setDeleteFlightModal({
            open: false,
            travelerId: "",
            flight: "",
            flightName: "",
          })
        }
        open={deleteFlightModal.open}
      />

      {/*DIALOG FOR DISABLE/ENABLE FLIGHT*/}
      <ModalDialog
        title={translateDisableModal() + " ?"}
      onOk={async () => {
        await refreshAccountAfterAction(
          disableFlight({
            travelerId: disableFlightModal.travelerId,
            flight: disableFlightModal.flight,
          }),
        );

        setDisableFlightModal(disableFlightModalState);
      }}
        onCancel={() => setDisableFlightModal(disableFlightModalState)}
        open={disableFlightModal.open}
      />

      <ModalDialog
        title={translateShowHideModal() + " ?"}
      onOk={async () => {
        await refreshAccountAfterAction(
          flightShow({
            travelerId: showedFlightModal.travelerId,
            flight: showedFlightModal.flight,
            body: { showed: showedFlightModal.status },
          }),
        );

        setShowedFlightModal(showedFlightModalState);
      }}
        onCancel={() => setShowedFlightModal(showedFlightModalState)}
        open={showedFlightModal.open}
      />

      <ModalDialog
        title={t(
          "app.main.schedules.module.title.1",
          "This action cancels the reservation!",
        )}
        onOk={async () => {
        await refreshAccountAfterAction(deleteSchedule({ id: modal.deleteId }));
        setModal({ open: false, deleteId: "" });
      }}
        onCancel={() => setModal({ open: false, deleteId: "" })}
        open={modal.open}
      />

      {noFlightModalOpen && (
        <div
          className={classes.noFlightModalOverlay}
          onClick={() => setNoFlightModalOpen(false)}
        >
          <div
            className={classes.noFlightModalCard}
            onClick={(e) => e.stopPropagation()}
          >
            <div className={classes.noFlightModalHeader}>
              {t("app.main.schedules.module.title.noshow", "No-show")}
            </div>
            <div className={classes.noFlightModalBody}>
              {t(
                "app.main.schedules.module.no.flight.selected",
                "You need to select a flight first.",
              )}
            </div>
            <div className={classes.noFlightModalFooter}>
              <button
                type="button"
                className={classes.noFlightModalButton}
                onClick={() => setNoFlightModalOpen(false)}
              >
                {t("app.main.schedules.module.ok", "OK")}
              </button>
            </div>
          </div>
        </div>
      )}

      <TableRow className={classes.root}>
        <TableCell align="left">
          <IconButton aria-label="expand row" size="small" onClick={toggleOpen}>
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>

        <TableCell align="left">
          <MultilineTableCell
            {...props}
            content={[
              <Box className={classes.textIconWrapper} key="conf">
                <Box fontWeight="fontWeightMedium" mr={2}>
                  #{confirmationCode}
                </Box>

                {!allTravellersDisabled && (
                  <IconButton size="small">
                    <Tooltip
                      title={`${t(
                        "app.main.schedules.tooltip.print.all.ticket.title",
                        "Print the ticket for all passengers",
                      )}`}
                    >
                      <IconButton
                        size="small"
                        onClick={onPrintAllTickets(props.row)}
                        disabled={printing}
                        aria-label="Print all tickets"
                      >
                        <PrintIcon className={classes.icon} />
                      </IconButton>
                    </Tooltip>
                  </IconButton>
                )}
              </Box>,

              externalReservationId ? (
                <Box key="ext" fontWeight="fontWeightMedium" color="textSecondary" style={{ fontSize: '0.75rem' }}>
                  Ref ID: {externalReservationId}
                </Box>
              ) : null,

              DateUtils.toHumanDate(
                DateUtils.convertDate(createdDate),
                new Date(createdDate).toLocaleTimeString("en-GB"),
              ),

              <Box
                key="created"
                fontWeight="fontWeightMedium"
                display="inline"
                className={createdByRole === "AGENT" ? classes.agent : ""}
              >
                {createdByRole}: {invoiceInTheNameOf}
              </Box>,
            ]}
          />
        </TableCell>

        <TableCell align="left">
          <MultilineTableCell
            {...props}
            content={[
              <div style={{ wordBreak: "break-word" }} key="note">
                <Box fontWeight="bold" display="inline">
                  {lastDisquisitions?.fullName
                    ? lastDisquisitions.fullName + " - "
                    : ""}
                </Box>
                {lastDisquisitions?.message}

                {hasNoteButton ? (
                  <Tooltip
                    title={`${t(
                      "app.main.schedules.tooltip.edit.note.title",
                      "Employee comments about the bill",
                    )}`}
                  >
                    <IconButton
                      size="small"
                      onClick={() => {
                        dispatch(toggleQuickPanel());
                        history.push({
                          pathname: `${url}/disquisitions/${id}`,
                          state: { disquisitions },
                        });
                      }}
                    >
                      <Icon className={classes.icon}>
                        <EditIcon />
                      </Icon>
                    </IconButton>
                  </Tooltip>
                ) : (
                  false
                )}
              </div>,
            ]}
          />
        </TableCell>

        <TableCell align="left">
          <MultilineTableCell
            content={[
              <div key="sup">
                {supervisor && (
                  <>
                    {hasChangeContactor ? (
                      <Tooltip
                        title={`${t(
                          "app.main.schedules.tooltip.edit.contact.person.title",
                          "Edit the contact person",
                        )}`}
                      >
                        <IconButton
                          disabled={status !== "ACTIVE"}
                          size="small"
                          onClick={() => {
                            dispatch(toggleQuickPanel());
                            history.push(`${url}/update-supervisor/${id}`);
                          }}
                        >
                          <Icon
                            color={
                              status === "CANCELLED" ? "disabled" : "inherit"
                            }
                            className={classes.icon}
                          >
                            <EditIcon />
                          </Icon>
                        </IconButton>
                      </Tooltip>
                    ) : (
                      false
                    )}
                    {supervisor} -{" "}
                    <Box fontWeight="fontWeightMedium" display="inline">
                      {languageOfSupervisor
                        ? languageOfSupervisor.toUpperCase()
                        : ""}
                    </Box>
                  </>
                )}
              </div>,

              <div key="phone">
                {contactNumber && (
                  <>
                    {hasConfirmViber ? (
                      <Tooltip
                        title={`${t(
                          "app.main.schedules.tooltip.edit.sms.title",
                          "Send the payment sms to the contact person",
                        )}`}
                      >
                        <IconButton
                          size="small"
                          onClick={() => {
                            dispatch(toggleQuickPanel());
                            history.push({
                              pathname: `${url}/sms/${id}`,
                              state: { smsResponses },
                            });
                          }}
                        >
                          <Icon className={classes.icon}>sms</Icon>
                        </IconButton>
                      </Tooltip>
                    ) : (
                      false
                    )}
                    {contactNumber}{" "}
                    {secondaryContactNumber
                      ? `/ ${secondaryContactNumber}`
                      : ""}
                  </>
                )}
              </div>,

              <div key="email">
                {emailOfSupervisor && (
                  <>
                    <Tooltip
                      title={`${t(
                        "app.main.schedules.tooltip.edit.email.title",
                        "Send the email sms to the contact person",
                      )}`}
                    >
                      <IconButton
                        disabled={allTravellersDisabled}
                        size="small"
                        onClick={() => {
                          dispatch(toggleQuickPanel());
                          history.push({
                            pathname: `${url}/email/${id}`,
                            state: { emailResponses },
                          });
                        }}
                      >
                        <Icon className={classes.icon}>email</Icon>
                      </IconButton>
                    </Tooltip>
                    {emailOfSupervisor}
                  </>
                )}
              </div>,
            ]}
          />
        </TableCell>

        <TableCell align="center">
          <MultilineTableCell content={[`${status} / ${source}`]} />
        </TableCell>

        <TableCell align="right">
          <MultilineTableCell
            content={[
              <div className={classes.textIconWrapper} key="total">
                <Icon className={classes.icon}>done</Icon>
                <span>
                  {t(
                    "app.main.schedules.sharedComponents.collapsibleTableRow.multilineTableCell.totalInvoice",
                    "Total invoice",
                  )}
                  :{" "}
                  <span style={{ fontWeight: 500 }}>
                    {invoice?.totalAmount} {currency?.symbol}
                  </span>
                </span>
              </div>,
              hasUserAnyAuthority([ROLES.ROLE_ADMIN]) ? (
                <div className={classes.textIconWrapper}>
                  <Tooltip
                    title={`${t("app.main.schedules.tooltip.edit.payment.title", "Pay the ticket")}`}
                  >
                    <IconButton
                      size="small"
                      disabled={status != "ACTIVE"}
                      onClick={() => {
                        dispatch(toggleQuickPanel());
                        history.push({
                          pathname: `${url}/payments/${id}`,
                        });
                      }}
                    >
                      <Icon className={classes.icon}>euro</Icon>
                    </IconButton>
                  </Tooltip>
                  <span>
                    {t(
                      "app.main.schedules.sharedComponents.collapsibleTableRow.multilineTableCell.amountPaid",
                      "Amount paid",
                    )}
                    :{" "}
                    <span style={{ fontWeight: 500 }}>
                      {invoice?.paymentAmount} {currency?.symbol}
                    </span>
                  </span>
                </div>
              ) : (
                <></>
              ),

              hasUserAnyAuthority([ROLES.ROLE_ADMIN]) ? (
                <>
                  {invoice?.debtAmount > 0 && (
                    <div className={classes.textIconWrapper}>
                      <Icon
                        className={classes.icon}
                        style={{ color: "#6c0d20" }}
                      >
                        warning
                      </Icon>
                      <span style={{ color: "#6c0d20", fontWeight: "bold" }}>
                        {t(
                          "app.main.schedules.sharedComponents.collapsibleTableRow.multilineTableCell.remainingDebt",
                          "Remaining debt",
                        )}
                        :{" "}
                        <span style={{ fontWeight: "bold" }}>
                          {invoice?.debtAmount} {currency?.symbol}
                        </span>
                      </span>
                    </div>
                  )}
                  {invoice?.debtAmount < 0 && (
                    <div className={classes.textIconWrapper}>
                      <Icon
                        className={classes.icon}
                        style={{ color: "#6c0d20" }}
                      >
                        warning
                      </Icon>
                      <span style={{ color: "#6c0d20", fontWeight: "bold" }}>
                        {t(
                          "app.main.schedules.sharedComponents.collapsibleTableRow.multilineTableCell.reimbursementAmount",
                          "Reimbursement amount",
                        )}
                        :{" "}
                        <span style={{ fontWeight: "bold" }}>
                          {invoice?.debtAmount} {currency?.symbol}
                        </span>
                      </span>
                    </div>
                  )}
                </>
              ) : (
                <></>
              ),
            ]}
          />
        </TableCell>
      </TableRow>

      <TableRow>
        <TableCell
          style={{
            paddingBottom: 0,
            paddingTop: 0,
            backgroundColor: "rgba(0,0,0,.03)",
          }}
          colSpan={12}
        >
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box margin={1}>
              <Typography variant="h6" gutterBottom component="div">
                {t(
                  "app.main.schedules.sharedComponents.collapsibleTableRow.typography",
                  "Passengers",
                )}
              </Typography>

              <Table size="small" aria-label="purchases">
                <TableHead>
                  <TableRow>
                    <TableCell align="left" style={{ width: "7rem" }} />
                    <TableCell
                      align="left"
                      style={{ fontWeight: "bold", width: "17rem" }}
                    >
                      {t(
                        "app.main.schedules.sharedComponents.collapsibleTableRow.tableCell1",
                        "Full name",
                      )}
                    </TableCell>
                    <TableCell align="left" style={{ fontWeight: "bold" }}>
                      {t(
                        "app.main.schedules.sharedComponents.collapsibleTableRow.tableCell2",
                        "From - To",
                      )}
                    </TableCell>
                    <TableCell style={{ fontWeight: "bold" }} align="right">
                      {t(
                        "app.main.schedules.sharedComponents.collapsibleTableRow.tableCell5",
                        "Baggage",
                      )}
                    </TableCell>
                    <TableCell style={{ fontWeight: "bold" }} align="right">
                      {t(
                        "app.main.schedules.sharedComponents.collapsibleTableRow.tableCell4",
                        "Tickets",
                      )}
                    </TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {travelers.map((trav: TravellerTypes, idx: number) => {
                    const isFlightDisabled =
                      !!trav.departureFlight?.isDisabled ||
                      !!trav.returningFlight?.isDisabled;

                    const hasSelectedFlight = (flight: any) =>
                      !!flight && (!!flight.id || !!flight.number);

                    const runIfAllowed = (callback: () => void) => {
                      const hasAnyFlight =
                        hasSelectedFlight(trav.departureFlight) ||
                        hasSelectedFlight(trav.returningFlight);
                      if (!hasAnyFlight) {
                        setNoFlightModalOpen(true);
                        return;
                      }
                      callback();
                    };

                    const runIfStatusActive = (callback: () => void) => {
                      if (status !== "ACTIVE") return;
                      callback();
                    };

                    return (
                      <TableRow
                        key={idx + trav.name + trav.dateOfBirth}
                        className={`${
                          trav.status
                            ? isFlightDisabled
                              ? classes.isDisabledFlight
                              : classes.passengersActive
                            : classes.passengersDisabled
                        }`}
                      >
                        <TableCell
                          align="left"
                          component="th"
                          scope="row"
                          style={{ width: "40px", padding: "4px 6px" }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "left",
                              fontSize: "12px",
                            }}
                          >
                            {idx + 1}).{" "}
                            {trav.departureFlight && (
                              <div
                                style={{
                                  fontWeight: "bold",
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <Icon
                                  fontSize="small"
                                  style={{ marginRight: "4px" }}
                                >
                                  flight
                                </Icon>
                                {trav.returningFlight ? "RT" : "OW"}
                              </div>
                            )}
                          </div>
                        </TableCell>

                        <TableCell align="left">
                          <MultilineTableCell
                            content={[
                              <>
                                {hasChangePassengerButton ? (
                                  <Tooltip
                                    title={
                                      t(
                                        "app.main.schedules.tooltip.edit.title",
                                        "Change the data of a passenger",
                                      ) || ""
                                    }
                                  >
                                    <span>
                                      <IconButton
                                        size="small"
                                        disabled={status !== "ACTIVE"}
                                        onClick={() =>
                                          runIfStatusActive(() => {
                                            dispatch(toggleQuickPanel());
                                            history.push({
                                              pathname: `${url}/update-traveler-flight/${trav.id}`,
                                              state: {
                                                passenger: trav,
                                                isChangingInfo: true,
                                                reservationId: id,
                                              },
                                            });
                                          })
                                        }
                                      >
                                        <Icon className={classes.icon}>
                                          <EditIcon />
                                        </Icon>
                                      </IconButton>
                                    </span>
                                  </Tooltip>
                                ) : (
                                  false
                                )}

                                <Box
                                  fontWeight="fontWeightMedium"
                                  display="inline"
                                >
                                  {checkAgeAndGender(
                                    trav.ageCategory,
                                    trav.gender,
                                  )}{" "}
                                  {trav.name} {trav.surname}
                                </Box>

                                {hasDeactivateButton ? (
                                  <>
                                    {trav.status ? (
                                      <Tooltip
                                        title={
                                          t(
                                            "app.main.schedules.tooltip.disable.passenger.title",
                                            "Disable passenger",
                                          ) || ""
                                        }
                                      >
                                        <span>
                                          <IconButton
                                            size="small"
                                            disabled={status !== "ACTIVE"}
                                            onClick={() =>
                                              runIfAllowed(() =>
                                                disableTravelerHandler(
                                                  id,
                                                  trav.id,
                                                  trav.ageCategory,
                                                  false,
                                                ),
                                              )
                                            }
                                          >
                                            <Icon className={classes.icon}>
                                              person_off
                                            </Icon>
                                          </IconButton>
                                        </span>
                                      </Tooltip>
                                    ) : (
                                      <Tooltip
                                        title={
                                          t(
                                            "app.main.schedules.tooltip.enable.passenger.title",
                                            "Enable passenger",
                                          ) || ""
                                        }
                                      >
                                        <span>
                                          <IconButton
                                            size="small"
                                            onClick={() =>
                                              disableTravelerHandler(
                                                id,
                                                trav.id,
                                                trav.ageCategory,
                                                true,
                                              )
                                            }
                                          >
                                            <Icon className={classes.icon}>
                                              person
                                            </Icon>
                                          </IconButton>
                                        </span>
                                      </Tooltip>
                                    )}
                                  </>
                                ) : (
                                  false
                                )}
                              </>,
                              <Box
                                className={classes.textIconWrapper}
                                key="pid"
                              >
                                <Box
                                  fontSize="13px"
                                  display="inline"
                                  marginRight="10px"
                                >
                                  {t(
                                    "app.main.schedules.sharedComponents.collapsibleTableRow.idPassenger",
                                    "Passenger ID",
                                  )}
                                  :{" "}
                                  <Box
                                    fontWeight="fontWeightMedium"
                                    display="inline"
                                  >
                                    {trav.number}
                                  </Box>
                                  {pnrCode && (
                                    <div style={{ marginTop: 4 }}>
                                      PNR: <b>{pnrCode}</b>
                                    </div>
                                  )}
                                </Box>

                                {trav.status && trav.departureFlight && (
                                  <Tooltip
                                    title={
                                      t(
                                        "app.main.schedules.tooltip.print.ticket.title",
                                        "Print the ticket for a passanger  ",
                                      ) || ""
                                    }
                                  >
                                    <span>
                                      <IconButton
                                        size="small"
                                        disabled={
                                          printing
                                        }
                                        onClick={() =>
                                          runIfAllowed(() => {
                                            onPrintTraveler(props.row, trav)();
                                          })
                                        }
                                      >
                                        <PrintIcon className={classes.icon} />
                                      </IconButton>
                                    </span>
                                  </Tooltip>
                                )}
                              </Box>,
                            ]}
                          />
                        </TableCell>

                        <TableCell align="left">
                          {trav.departureFlight && (
                            <div>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "6px",
                                }}
                              >
                                {hasChangeTravelerFlight ? (
                                  <Tooltip
                                    title={
                                      t(
                                        "app.main.schedules.tooltip.edit.one.way.ticket.title",
                                        "Edit the departure flight (from - to)",
                                      ) || ""
                                    }
                                  >
                                    <span>
                                      <IconButton
                                        size="small"
                                        disabled={status !== "ACTIVE"}
                                        onClick={() =>
                                          runIfStatusActive(() => {
                                            dispatch(toggleQuickPanel());
                                            history.push({
                                              pathname: `${url}/update-passenger-flight/${id}`,
                                              state: {
                                                passenger: trav,
                                                departureFlight:
                                                  trav.departureFlight,
                                              },
                                            });
                                          })
                                        }
                                      >
                                        <Icon className={classes.icon}>
                                          <EditIcon />
                                        </Icon>
                                      </IconButton>
                                    </span>
                                  </Tooltip>
                                ) : (
                                  false
                                )}

                                {trav.departureFlight?.number && (
                                  <div className={classes.textBold}>
                                    {trav.departureFlight.number}
                                    <br />
                                    <p style={{ color: "red" }}>
                                      {trav.departureSeat?.seatNumber}
                                    </p>
                                  </div>
                                )}
                              </div>

                              <div
                                className={`${classes.inline}
                          ${trav.departureFlight.showed ? "" : classes.lineThrough}
                          ${
                            trav.departureFlight.isDisabled
                              ? `${classes.textRed} ${classes.lineThrough}`
                              : ""
                          }`}
                              >
                                <span className={classes.box}>
                                  {`${trav.departureFlight?.departureAirport?.code} - ${trav.departureFlight?.arrivalAirport?.code}`}
                                </span>
                                {DateUtils.toHumanDate(
                                  DateUtils.convertDate(
                                    trav.departureFlight?.dateOfDeparture,
                                  ),
                                  trav.departureFlight?.timeOfDeparture?.toString(),
                                )}
                              </div>

                              {hasShowButton && trav.departureFlight ? (
                                <Tooltip
                                  title={
                                    t(
                                      "app.main.schedules.tooltip.no.show.title",
                                      "Change the status of the booking as no-show",
                                    ) || ""
                                  }
                                >
                                  <span>
                                    <IconButton
                                      size="small"
                                      disabled={
                                        status !== "ACTIVE" 
                                      }
                                      className={classes.marginLeft10}
                                      onClick={() =>
                                        runIfStatusActive(() =>
                                          showedFlightHandler(
                                            trav.id,
                                            !trav.departureFlight?.showed,
                                            "departureFlight",
                                            trav.departureFlight
                                              ?.departureAirport?.code,
                                            trav.departureFlight
                                              ?.arrivalAirport?.code,
                                          ),
                                        )
                                      }
                                    >
                                      <Icon className={classes.icon}>
                                        {trav.departureFlight.showed
                                          ? "visibility_off"
                                          : "visibility"}
                                      </Icon>
                                    </IconButton>
                                  </span>
                                </Tooltip>
                              ) : (
                                false
                              )}

                              {(hasUserAnyAuthority([ROLES.ROLE_ADMIN]) ||
                                hasUserAnyAuthority([
                                  ROLES.ROLE_AGENT,
                                  ROLES.ROLE_SUB_AGENT,
                                ])) &&
                              hasDeleteFlightButton &&
                              !isPastFlight &&
                              trav.returningFlight ? (
                                <Tooltip
                                  title={
                                    t(
                                      "app.main.schedules.tooltip.delete.title",
                                      "Delete the booking flight",
                                    ) || ""
                                  }
                                >
                                  <span>
                                    <IconButton
                                      size="small"
                                      disabled={
                                        status !== "ACTIVE" 
                                      }
                                      onClick={() =>
                                        runIfStatusActive(() =>
                                          deleteFlightHandler(
                                            trav.id,
                                            "departureFlight",
                                            trav.departureFlight
                                              ?.departureAirport?.code,
                                            trav.departureFlight
                                              ?.arrivalAirport?.code,
                                          ),
                                        )
                                      }
                                    >
                                      <Icon className={classes.icon}>
                                        delete_outline
                                      </Icon>
                                    </IconButton>
                                  </span>
                                </Tooltip>
                              ) : null}
                            </div>
                          )}

                          {canBookFlights && !trav.departureFlight && (
                            <div>
                              <span
                                className={classes.addReturnFlightBtn}
                                onClick={() =>
                                  runIfAllowed(() => {
                                    dispatch(toggleQuickPanel());
                                    history.push({
                                      pathname: `${url}/add-passenger-return-flight/${id}`,
                                      state: {
                                        passenger: trav,
                                        flightWay: "ONE_WAY",
                                        reservationId: id,
                                      },
                                    });
                                  })
                                }
                                style={{
                                  pointerEvents:
                                    status !== "ACTIVE"
                                      ? "none"
                                      : "auto",
                                  opacity: status !== "ACTIVE"
                                    ? 0.5
                                    : 1,
                                  cursor: status !== "ACTIVE"
                                    ? "not-allowed"
                                    : "pointer",
                                }}
                              >
                                <Icon className={classes.icon}>
                                  add_circle_outline
                                </Icon>
                                {t(
                                  "app.main.schedules.sharedComponents.collapsibleTableRow.bookOWFlight",
                                  "Book Going Flight",
                                )}
                              </span>
                            </div>
                          )}
                          <IconButton
                            size="small"
                            disabled={
                              status !== "ACTIVE"
                            }
                          >
                            {canBookFlights &&
                              trav.departureFlight &&
                              !trav.returningFlight && (
                                <div>
                                  <span
                                    className={classes.addReturnFlightBtn}
                                    onClick={() =>
                                      runIfAllowed(() => {
                                        dispatch(toggleQuickPanel());
                                        history.push({
                                          pathname: `${url}/add-passenger-return-flight/${id}`,
                                          state: {
                                            passenger: trav,
                                            flightWay: "RETURN_WAY",
                                          },
                                        });
                                      })
                                    }
                                    style={{
                                      pointerEvents:
                                        status !== "ACTIVE"
                                          ? "none"
                                          : "auto",
                                      opacity:
                                        status !== "ACTIVE"
                                          ? 0.5
                                          : 1,
                                      cursor:
                                        status !== "ACTIVE"
                                          ? "not-allowed"
                                          : "pointer",
                                    }}
                                  >
                                    <Icon className={classes.icon}>
                                      add_circle_outline
                                    </Icon>

                                    {t(
                                      "app.main.schedules.sharedComponents.collapsibleTableRow.bookReturnFlight",
                                      "Book Return Flight",
                                    )}
                                  </span>
                                </div>
                              )}
                          </IconButton>

                          {trav.returningFlight && (
                            <div>
                              {hasReturnTravelerFlight && (
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "6px",
                                  }}
                                >
                                  <Tooltip
                                    title={
                                      t(
                                        "app.main.schedules.tooltip.edit.return.way.ticket.title",
                                        "Edit the arrival flight (from - to)",
                                      ) || ""
                                    }
                                  >
                                    <span>
                                      <IconButton
                                        size="small"
                                        disabled={
                                          status !== "ACTIVE"
                                        }
                                        onClick={() =>
                                          runIfStatusActive(() => {
                                            dispatch(toggleQuickPanel());
                                            history.push({
                                              pathname: `${url}/update-passenger-flight/${id}`,
                                              state: {
                                                passenger: trav,
                                                returnFlight:
                                                  trav.returningFlight,
                                              },
                                            });
                                          })
                                        }
                                      >
                                        <Icon className={classes.icon}>
                                          <EditIcon />
                                        </Icon>
                                      </IconButton>
                                    </span>
                                  </Tooltip>

                                  {trav.returningFlight.number && (
                                    <div className={classes.textBold}>
                                      {trav.returningFlight.number}
                                      <br />
                                      <p style={{ color: "red" }}>
                                        {trav.returnSeat?.seatNumber}
                                      </p>
                                    </div>
                                  )}
                                </div>
                              )}

                              <div
                                className={`${classes.inline}
                          ${trav.returningFlight.showed ? "" : classes.lineThrough}
                          ${trav.returningFlight.isDisabled ? classes.textRed : ""}`}
                              >
                                <span className={classes.box}>
                                  {`${trav.returningFlight?.departureAirport?.code} - ${trav.returningFlight?.arrivalAirport?.code}`}
                                </span>
                                {DateUtils.toHumanDate(
                                  DateUtils.convertDate(
                                    trav.returningFlight?.dateOfDeparture,
                                  ),
                                  trav.returningFlight?.timeOfDeparture?.toString(),
                                )}
                              </div>

                              {hasShowButton &&
                              trav.returningFlight &&
                              canBookFlights ? (
                                <Tooltip
                                  title={
                                    t(
                                      "app.main.schedules.tooltip.no.show.title",
                                      "Change the status of the booking as no-show",
                                    ) || ""
                                  }
                                >
                                  <span>
                                    <IconButton
                                      size="small"
                                      disabled={
                                        status !== "ACTIVE"
                                      }
                                      className={classes.marginLeft10}
                                      onClick={() =>
                                        runIfStatusActive(() =>
                                          showedFlightHandler(
                                            trav.id,
                                            !trav.returningFlight?.showed,
                                            "returnFlight",
                                            trav.returningFlight
                                              ?.departureAirport?.code,
                                            trav.returningFlight
                                              ?.arrivalAirport?.code,
                                          ),
                                        )
                                      }
                                    >
                                      <Icon className={classes.icon}>
                                        {trav.returningFlight.showed
                                          ? "visibility_off"
                                          : "visibility"}
                                      </Icon>
                                    </IconButton>
                                  </span>
                                </Tooltip>
                              ) : (
                                false
                              )}

                              {trav.returningFlight && canBookFlights ? (
                                <Tooltip
                                  title={
                                    t(
                                      "app.main.schedules.tooltip.deactivate.title",
                                      "Deactivate the booking flight",
                                    ) || ""
                                  }
                                >
                                  <span>
                                    <IconButton
                                      size="small"
                                      disabled={
                                        status != "ACTIVE" 
                                      }
                                      onClick={() =>
                                        runIfStatusActive(() => {
                                          if (
                                            trav.returningFlight?.isDisabled
                                          ) {
                                            dispatch(toggleQuickPanel());
                                            history.push({
                                              pathname: `${url}/enable-traveler-flight/${id}`,
                                              state: {
                                                passenger: trav,
                                                flightWay: "RETURN_WAY",
                                                reActivateflight:
                                                  trav.returningFlight,
                                              },
                                            });
                                            return;
                                          }

                                          disableFlightHandler(
                                            trav.id,
                                            "returnFlight",
                                            trav.returningFlight
                                              ?.departureAirport?.code,
                                            trav.returningFlight
                                              ?.arrivalAirport?.code,
                                          );
                                        })
                                      }
                                    >
                                      <Icon className={classes.icon}>
                                        {trav.returningFlight.isDisabled
                                          ? "done"
                                          : "not_interested"}
                                      </Icon>
                                    </IconButton>
                                  </span>
                                </Tooltip>
                              ) : (
                                false
                              )}

                              {(hasUserAnyAuthority([ROLES.ROLE_ADMIN]) ||
                                hasUserAnyAuthority([
                                  ROLES.ROLE_AGENT,
                                  ROLES.ROLE_SUB_AGENT,
                                ])) &&
                              hasDeleteFlightButton &&
                              trav.departureFlight ? (
                                <Tooltip
                                  title={
                                    t(
                                      "app.main.schedules.tooltip.delete.title",
                                      "Delete the booking flight",
                                    ) || ""
                                  }
                                >
                                  <span>
                                    <IconButton
                                      size="small"
                                      disabled={
                                        status !== "ACTIVE" 
                                      }
                                      onClick={() =>
                                        runIfStatusActive(() =>
                                          deleteFlightHandler(
                                            trav.id,
                                            "returnFlight",
                                            trav.returningFlight
                                              ?.departureAirport?.code,
                                            trav.returningFlight
                                              ?.arrivalAirport?.code,
                                          ),
                                        )
                                      }
                                    >
                                      <Icon className={classes.icon}>
                                        delete_outline
                                      </Icon>
                                    </IconButton>
                                  </span>
                                </Tooltip>
                              ) : (
                                false
                              )}
                            </div>
                          )}
                        </TableCell>

                        {/* BAGGAGE */}
                        <TableCell align="right">
                          {!trav.status ? (
                            <div>
                              <div>-</div>
                              {trav.returningFlight && <div>-</div>}
                            </div>
                          ) : (
                            <div>
                              <div className={classes.priceFlex}>
                                {trav.departureBaggages?.length ? (
                                  <div>
                                    <p>
                                      <Icon
                                        fontSize="small"
                                        style={{ marginRight: "4px" }}
                                      >
                                        arrow_upward
                                      </Icon>
                                      <span className={classes.textBold}>
                                        {trav.departureBaggages.map(
                                          (b, index) => (
                                            <span key={index}>
                                              {b.quantity > 1
                                                ? `${b.quantity}x`
                                                : ""}
                                              {b.weight}
                                              {b.unit ?? "kg"}
                                              {index <
                                              trav.departureBaggages.length - 1
                                                ? ", "
                                                : ""}
                                            </span>
                                          ),
                                        )}
                                      </span>
                                    </p>
                                  </div>
                                ) : (
                                  <div>-</div>
                                )}

                                {trav.returnBaggages?.length &&
                                trav.returningFlight ? (
                                  <div>
                                    <p>
                                      <Icon
                                        fontSize="small"
                                        style={{ marginRight: "4px" }}
                                      >
                                        arrow_downward
                                      </Icon>
                                      <span className={classes.textBold}>
                                        {trav.returnBaggages.map((b, index) => (
                                          <span key={index}>
                                            {b.quantity > 1
                                              ? `${b.quantity}x`
                                              : ""}
                                            {b.weight}
                                            {b.unit ?? "kg"}
                                            {index <
                                            trav.returnBaggages.length - 1
                                              ? ", "
                                              : ""}
                                          </span>
                                        ))}
                                      </span>
                                    </p>
                                  </div>
                                ) : (
                                  trav.returningFlight && <div>-</div>
                                )}
                              </div>
                            </div>
                          )}
                        </TableCell>

                        <div className={classes.ticketColumn}>
                          <div className={classes.flightPrices}>
                            {trav.departureFlight && (
                              <div className={classes.priceLine}>
                                <span className={classes.textBold}>
                                  {Number(
                                    trav.price?.departureFlightPrice ?? 0,
                                  )}{" "}
                                  {currency?.symbol}
                                </span>
                              </div>
                            )}

                            {trav.returningFlight && (
                              <div className={classes.priceLine}>
                                <span className={classes.textBold}>
                                  {Number(
                                    trav.price?.returningFlightPrice ?? 0,
                                  )}{" "}
                                  {currency?.symbol}
                                </span>
                              </div>
                            )}
                          </div>

                          <div className={classes.ticketTotals}>
                            <div className={classes.priceRow}>
                              {hasPriceButton && (
                                <Tooltip
                                  title={
                                    t(
                                      "app.main.schedules.tooltip.edit.ticket.title",
                                      "Edit flight ticket",
                                    ) || ""
                                  }
                                >
                                  <span>
                                    <IconButton
                                      size="small"
                                      disabled={status !== "ACTIVE"}
                                      onClick={() =>
                                        runIfAllowed(() => {
                                          dispatch(toggleQuickPanel());
                                          history.push({
                                            pathname: `${url}/update-traveler-flight/${id}`,
                                            state: { passenger: trav },
                                          });
                                        })
                                      }
                                    >
                                      <Icon>
                                        <EditIcon />
                                      </Icon>
                                    </IconButton>
                                  </span>
                                </Tooltip>
                              )}

                              <span>
                                Ticket:{" "}
                                <b>
                                  {Number(
                                    trav.price?.departureFlightPrice ?? 0,
                                  ) +
                                    Number(
                                      trav.price?.returningFlightPrice ?? 0,
                                    )}{" "}
                                  {currency?.symbol}
                                </b>
                              </span>
                              <p>
                                {t(
                                  "app.main.schedules.sharedComponents.collapsibleTableRow.tableCell3",
                                  "Base price",
                                )}
                                :{" "}
                                <span className={classes.textBold}>
                                  {trav.price?.departureBaseFlightPrice! +
                                    trav.price?.returningBaseFlightPrice!}{" "}
                                  {currency?.symbol}
                                </span>
                              </p>
                            </div>
                          </div>
                        </div>
                      </TableRow>
                    );
                  })}

                  <TableRow style={{ backgroundColor: "#f2f2f2" }}>
                    <TableCell
                      colSpan={12}
                      style={{ textAlign: "right", border: "none" }}
                    >
                      <p>
                        {t(
                          "app.main.schedules.sharedComponents.collapsibleTableRow.ticket",
                          "Ticket",
                        )}
                        :{" "}
                        {hasUserAnyAuthority([ROLES.ROLE_ADMIN]) ? (
                          <>
                            <span>
                              <b>
                                {(invoice as any).amount} {currency?.symbol}
                              </b>
                            </span>{" "}
                            |{" "}
                          </>
                        ) : (
                          <>
                            <span>
                              <b>
                                {invoice?.totalAmount} {currency?.symbol}
                              </b>
                            </span>{" "}
                            |{" "}
                          </>
                        )}
                        {t(
                          "app.main.schedules.sharedComponents.collapsibleTableRow.taxes",
                          "Taxes",
                        )}
                        :{" "}
                        <span>
                          <b>
                            {(invoice as any).tax} {currency?.symbol}
                          </b>
                        </span>{" "}
                        |{" "}
                        {t(
                          "app.main.schedules.sharedComponents.collapsibleTableRow.discount",
                          "Discount",
                        )}
                        :{" "}
                        <span>
                          <b>
                            {(invoice as any).discount} {currency?.symbol}
                          </b>
                        </span>{" "}
                        |{" "}
                        {t(
                          "app.main.agency.edit.provision.title1",
                          "Provision",
                        )}
                        :{" "}
                        <span>
                          <b>
                            {provision} {currency?.symbol}
                          </b>
                        </span>
                      </p>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>

      <TableRow>
        <TableCell className={classes.rowButtons} colSpan={12}>
          {hasButton ? (
            <Button
              onClick={() => {
                dispatch(toggleQuickPanel());
                history.push({
                  pathname: `${url}/add-passenger/${id}`,
                  state: { reservation: props.row },
                });
              }}
              size="small"
              variant="outlined"
              disabled={status !== "ACTIVE"}
            >
              <PersonAddOutlinedIcon fontSize="small" />
              &nbsp;{" "}
              {t(
                "app.main.schedules.sharedComponents.collapsibleTableRow.addPassenger",
                "Add Passenger",
              )}
            </Button>
          ) : (
            false
          )}

          {travelers?.length > 1 &&
            (hasSplitButton ? (
              <Button
                onClick={() => {
                  dispatch(toggleQuickPanel());
                  history.push({
                    pathname: `${url}/split-passengers/${id}`,
                    state: { passengers: travelers },
                  });
                }}
                size="small"
                variant="outlined"
                disabled={status !== "ACTIVE"}
              >
                <Icon fontSize="small">people_outline</Icon>
                &nbsp;{" "}
                {t(
                  "app.main.schedules.sharedComponents.collapsibleTableRow.shareTheReservation",
                  "Split the reservation",
                )}
              </Button>
            ) : (
              false
            ))}

          {hasActivitiesButton ? (
            <Button
              size="small"
              variant="outlined"
              onClick={() => history.push(`/schedules/${id}/activities`)}
              disabled={status !== "ACTIVE"}
            >
              <Icon fontSize="small">history</Icon>
              &nbsp;{" "}
              {t(
                "app.main.schedules.sharedComponents.collapsibleTableRow.activities",
                "Historiku",
              )}
            </Button>
          ) : (
            false
          )}

          {status === "DISABLED" && hasCancelButton &&
            hasUserAnyAuthority([
              ROLES.ROLE_ADMIN, ROLES.ROLE_AGENT, ROLES.ROLE_SUB_AGENT,
            ]) && (
              <Button
                size="small"
                variant="outlined"
                disabled={restoring}
                onClick={restoreReservation}
              >
                <Icon fontSize="small">restore</Icon>
                &nbsp;{restoring
                  ? t("app.main.schedules.restore.loading", "Restoring…")
                  : t("app.main.schedules.restore.button", "Restore")}
              </Button>
            )}

          {(hasUserAnyAuthority([ROLES.ROLE_ADMIN]) ||
            hasUserAnyAuthority([ROLES.ROLE_AGENT, ROLES.ROLE_SUB_AGENT])) &&
          hasCancelButton ? (
            <Button
              size="small"
              variant="outlined"
              disabled={status !== "ACTIVE"}
              onClick={() => deleteReservationHandler(id)}
            >
              <Icon fontSize="small">delete</Icon>
              {t(
                "app.main.flights.flightList.deletePopup.cancelButton",
                "Cancel",
              )}
            </Button>
          ) : (
            <></>
          )}
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
};

export default CollapsibleTableRow;
